import { Product } from '../interfaces';

interface ProductERPWithProducts {
  products?: Array<{
    product: number;
    plan?: number | null;
  }>;
}

export const getProductsForLevel = (
  products: Product[],
  productERP: ProductERPWithProducts,
  levelRank: number,
) => {
  if (!productERP?.products?.length) return [];

  return products.filter((product) => {
    const plansForLevel =
      (product.plans || []).filter((planItem) => planItem.level?.rank === levelRank) || [];

    if (plansForLevel.length === 0) {
      return productERP.products?.some((erpProduct) => erpProduct.product === product.id);
    }

    return plansForLevel.some((planOption) =>
      productERP.products?.some(
        (erpProduct) => erpProduct.product === product.id && erpProduct.plan === planOption.id,
      ),
    );
  });
};

